import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import t1 from "../../Assets/mobile-app-development/user1.png"
import t2 from "../../Assets/mobile-app-development/user2.png"
import t3 from "../../Assets/mobile-app-development/user3.png"

const data = [
    {
        id: 1,
        image: t1,
        title: "A Mobile-First and SEO-Ready Strategy",
        name: "Sara D.",
        position: "— Lifestyle App's Head of Marketing",
        feedback:
            "We wanted more than simply an app; we wanted it to function flawlessly on mobile devices and rank well. They succeeded in both areas. Within weeks, traffic and interaction increased.",
    },
    {
        id: 2,
        image: t2,
        title: "Support & Maintenance Around-the-Clock",
        name: "Kritika R.",
        position: "— HealthTech Company's Operations Lead",
        feedback:
            "For other teams, post-launch assistance might be a nightmare. Not in this place. They are constantly accessible, even for minor upgrades or fixes. complete tranquility of mind.",
    },
    {
        id: 3,
        image: t3,
        title: "Committed Internal Staff",
        name: "Fatima K.",
        position: "— Product Manager, Dubai-based E-commerce Brand",
        feedback:
            "To be honest, they seemed to be members of our own team. Extremely available, responsive, and sincere in wanting the project to succeed.",
    }
];

const settings = {
    dots: false,
    arrows: true,
    autoplay: false,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    cssEase: "ease-in-out",
    nextArrow: <img src="./testimonial-button.png" alt="Next" className="nextArrow" />,
    prevArrow: <img src="./testimonial-button.png" alt="Previous" className="prevArrow" />,
    responsive: [
        {
            breakpoint: 1150,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: false,
                autoplay: true,
            },
        },
        {
            breakpoint: 700,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide: 1,
                arrows: false,
                autoplay: true,
            },
        },
    ],
};
const Testimonials = () => {
    return (
        <div id='mobile-app-testimonials'>
            <div className="section">
                <div className="container">
                    <h2 className="heading">
                        What Our Clients Say
                    </h2>
                    <Slider {...settings}>
                        {data.map((item) => {
                            return (
                                <div className="fwrapper" key={item.id}>
                                    <div className="fbox">
                                        <div className="symbolbox">
                                            <img src="./testimonial-quote.png" alt="" className="symbolimage" />
                                        </div>
                                        <div className="fcontent">
                                            <h3>{item.title}</h3>
                                            <p>{item.feedback}</p>
                                            <div className="personinfo">
                                                <h3>{item.name}</h3>
                                                <h4>{item.position}</h4>
                                            </div>
                                        </div>
                                        <div className="profilebox">
                                            <img src={item.image} alt="" className="profileimage" />
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default Testimonials